__turbopack_context__.v({
  "className": "inter_d3d89afe-module__0_YTTG__className",
});
